"use strict";

import { mod_loader } from './AppState.js';
import { get_pub_key, pubkey_exists } from './crypt_helper.js';

const el_modal = document.getElementById('myModal') || console.log("Cannot read myModal.");

let g_modal = null;
try {
    g_modal = bootstrap.Modal.getOrCreateInstance(el_modal); // Returns a Bootstrap modal instance
} catch (e) {
    console.log(e);
    console.log("Cannot create modal instance.");
}

export function spinner_main_window(element, loading_status) {
    if (loading_status == true)
        element.classList.add('spinner-grow');
    else
        element.classList.remove('spinner-grow');
}

// --------------------------------------------------------------------------
export async function postData(url = "", data = {}, btn_element) {

    // TODO: handle the rate-limit

    function setButtonLoading(button, isLoading) {

        if (!button) return;

        let spinner = button.querySelector(":scope > ._btn-spinner");

        if (isLoading && spinner) return; // already loading

        if (isLoading) {
            // Create spinner element
            const spinnerClass = "spinner-border spinner-border-sm me-2"
            spinner = document.createElement("span");
            spinner.className = `${spinnerClass} _btn-spinner`;
            spinner.setAttribute("aria-hidden", "true");

            // Create accessible text (visually hidden)
            const srText = document.createElement("span");
            srText.className = "visually-hidden";
            srText.setAttribute("role", "status");
            srText.textContent = "Loading...";

            spinner.appendChild(srText);

            // Insert spinner at the beginning
            button.prepend(spinner);

            button.disabled = true;

            return;
        }

        // Stop the spinner
        if (spinner)
            spinner.remove();

        button.disabled = false;

    } // end setButtonLoading

    spinner_main_window($('navbar_loading_spinner'), true);

    setButtonLoading(btn_element, true);

    let response_json;
    try {
        const response = await fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (response.status === 404)
            throw new Error('Page not found (404)');

        if (response.status === 413)
            throw new Error('Payload too large (413)');

        if (response.status === 429)
            throw new Error('Too many requests (429)');

        if (!response.ok)
            throw new Error(`HTTP error ${response.status}`);

        response_json = await response.json();

        if (response_json?.error == "too_many_requests")
            throw new Error("Rate limit exceeded. Please try again later." + (response_json?.message ?? ""));

        if (response_json?.success !== true)
            throw new Error("Error on POST data (response_json not success). Please try again later." + (response_json?.message ?? ""));

    } catch (error) {
        console.log(error);
        console.log('Error fetching data:');
        console.log("response_json:", response_json);
        if (error instanceof TypeError && error.message.includes('Failed to fetch'))
            console.log('Network error: The request failed to fetch. Check connection/CORS.');
        throw error;
    } finally {
        spinner_main_window($('navbar_loading_spinner'), false);
        setButtonLoading(btn_element, false);
    }

    return response_json
}

// --------------------------------------------------------------------------

export function toaster(message) {

    if (isString(message))
        message = { title: "Alert", body: message }

    message.title ??= "";
    message.body ??= "";

    if (!isString(message.body)) {
        message.body = JSON.stringify(message.body);
    }

    const toast_master = document.getElementById("toast_template");
    const cloned = toast_master.cloneNode(true);

    if (message.severity == true) {
        cloned.classList.add("text-bg-warning");
    }

    cloned.querySelector(".toaster_title").innerText = message.title.substring(0, 100);

    cloned.querySelector(".toast-body").innerText = message.body.substring(0, 200);

    if (message.onclick_module) {

        cloned.style.cursor = "pointer";

        cloned.querySelector(".toast-body").addEventListener('click', (e) => {
            if (e.target.closest(".btn-close")) return;
            mod_loader(message.onclick_module, { key: message.key })
            toast.hide()
        });
    }

    toast_master.parentElement.append(cloned)

    const toast = new bootstrap.Toast(cloned, {
        autohide: false
    });

    toast.show();

}
// --------------------------------------------------------------------------
export async function show_modal(title, body, on_btn_close) {

    console.trace("show modal");
    const btn_close = document.getElementById("myModal").querySelector('button[name="btn_modal_close"]')
    if (on_btn_close) {
        if (on_btn_close.action == "redirect")
            btn_close.setAttribute('onclick', `document.location.href = "${on_btn_close.url}"`)
        btn_close.innerText = on_btn_close.btn_text
    }

    document.getElementById("myModal").getElementsByClassName("modal-title")[0].innerText = title
    document.getElementById("myModal").getElementsByClassName("modal-body")[0].innerText = body
    try {
        await g_modal.show();
    } catch (e) {
        console.error(e)
    }

}
// --------------------------------------------------------------------------

function isString(value) {
    return typeof value === 'string' || value instanceof String
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};
// --------------------------------------------------------------------------

export function copy_to_clipboard(el) {

    const icon = el.querySelector(".bi-copy")

    if (icon == null) return console.log("Too fast...");

    icon.classList.replace("bi-copy", "bi-check-lg")

    const el_copy = el.parentNode.parentNode.querySelector(".clipboard_target_data")

    el_copy.select();

    el_copy.setSelectionRange(0, 99999); // For mobile devices

    navigator.clipboard.writeText(el_copy.value);

    setTimeout(() => {
        icon.classList.replace("bi-check-lg", "bi-copy");
    }, 2000);

}
// -------------------------------------------------
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
// -------------------------------------------------

export async function update_username() {

    const user = await get_pub_key()

    $e(document).getEl("icon_person_login").classList.remove("bi-dash-circle-dotted");

    if (!user) {
        $e(document).getEl("icon_person_login").classList.add("bi-plus-circle-dotted");
        return;
    }

    styleAvatar($e(document).getEl("avatar_login"), { fullname: user.myKeyPairUserID[0], pgp_pubkey: user.myKeyPairPublicKey }, 36);

    $e(document).getEl("icon_person_login").classList.add("d-none");

}
// -------------------------------------------------
export function collapse_show(element) {
    const element_bollapse = new bootstrap.Collapse(element, { toggle: false });
    element_bollapse.show()
    return element_bollapse
}
// -------------------------------------------------
export function collapse_hide(element) {
    const element_bollapse = new bootstrap.Collapse(element, { toggle: false });
    element_bollapse.hide()
    return element_bollapse
}
// -------------------------------------------------
// Convert VAPID key
export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

// -------------------------------------------------

export function form_validate(root, callback_success, callback_error) {
    for (const form of root.querySelectorAll('.needs-validation')) {

        form.addEventListener('submit', async event => {
            event.preventDefault(); // always block default submit
            event.stopPropagation();

            if (!form.checkValidity()) {
                // ❌ invalid form → show Bootstrap validation styles

                form.classList.add('was-validated');
                return;
            }

            // ✔ Valid form → execute            
            callback_success(event)

        })

    }
}
// -------------------------------------------------

const activeEffects = new Map();

export function matrix_effect(element, enable, text) {
    // Handle both element objects and string IDs
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }

    if (!element) {
        console.error('Element not found');
        return;
    }

    const elementId = element.id || `matrix-${Date.now()}`;
    if (!element.id) element.id = elementId;

    if (enable) {
        // Don't create duplicate overlays
        if (activeEffects.has(elementId)) {
            return;
        }

        // Ensure element has position context
        const computedStyle = window.getComputedStyle(element);
        if (computedStyle.position === 'static') {
            element.style.position = 'relative';
        }

        // Create overlay container
        const overlay = document.createElement('div');
        overlay.className = 'matrix-overlay';

        // Create canvas
        const canvas = document.createElement('canvas');
        overlay.appendChild(canvas);

        // Create status text
        const status = document.createElement('div');
        status.className = 'status';
        status.textContent = text != null ? text : 'ENCRYPTING...';
        status.style.color = text != null ? "red" : "green";
        status.style.fontWeight = '700';
        status.style.fontSize = '25px';

        overlay.appendChild(status);

        // Add overlay to element
        element.appendChild(overlay);

        // Initialize canvas
        const ctx = canvas.getContext('2d');
        canvas.width = element.clientWidth;
        canvas.height = element.clientHeight;

        // Matrix characters
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*()ｦｱｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ';
        const charArray = chars.split('');

        const fontSize = 18;
        const columns = canvas.width / fontSize;
        const drops = [];
        const speeds = [];

        // Initialize drops
        for (let i = 0; i < columns; i++) {
            drops[i] = Math.random() * -canvas.height / fontSize;
            speeds[i] = 0.5 + Math.random() * 0.8;
        }

        function draw() {
            ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.font = fontSize + 'px monospace';

            for (let i = 0; i < drops.length; i++) {
                const x = i * fontSize;
                const y = drops[i] * fontSize;
                const trailLength = 20 + Math.floor(Math.random() * 10);

                for (let j = 0; j < trailLength; j++) {
                    const trailY = y - (j * fontSize);

                    if (trailY > 0 && trailY < canvas.height) {
                        if (j === 0) {
                            ctx.fillStyle = '#fff';
                            ctx.shadowBlur = 10;
                            ctx.shadowColor = '#0f0';
                        } else if (j < 3) {
                            ctx.fillStyle = '#0f0';
                            ctx.shadowBlur = 5;
                            ctx.shadowColor = '#0f0';
                        } else {
                            const alpha = 1 - (j / trailLength);
                            ctx.fillStyle = `rgba(0, 255, 0, ${alpha * 0.8})`;
                            ctx.shadowBlur = 0;
                        }

                        const trailChar = charArray[Math.floor(Math.random() * charArray.length)];
                        ctx.fillText(trailChar, x, trailY);
                    }
                }

                drops[i] += speeds[i];

                if (drops[i] * fontSize > canvas.height + trailLength * fontSize) {
                    drops[i] = -trailLength;
                    speeds[i] = 0.1 + Math.random() * 0.8;
                }
            }

            ctx.shadowBlur = 0;
        }

        // Start animation
        const intervalId = setInterval(draw, 33);

        // Handle resize
        const resizeHandler = () => {
            canvas.width = element.clientWidth;
            canvas.height = element.clientHeight;
        };
        window.addEventListener('resize', resizeHandler);

        // Store effect data
        activeEffects.set(elementId, {
            overlay: overlay,
            intervalId: intervalId,
            resizeHandler: resizeHandler
        });

    } else {
        // Stop and remove effect
        const effect = activeEffects.get(elementId);
        if (effect) {
            clearInterval(effect.intervalId);
            window.removeEventListener('resize', effect.resizeHandler);
            effect.overlay.remove();
            activeEffects.delete(elementId);
        }
    }
}
// -------------------------------------------------
export function navbar_active_menu(item) {

    const navbar = document.querySelector("nav")

    for (const navlink of navbar.querySelectorAll(".nav-link"))
        navlink.classList.remove("active")

    for (const navlink of navbar.querySelectorAll(".dropdown-item"))
        navlink.classList.remove("active")

    navbar.querySelector(item).classList.add("active")

}
// -------------------------------------------------
export async function showOffcanvas(offcanva_id, callback) {

    const offcanvasEl = document.getElementById(offcanva_id);

    if (offcanva_id == 'offcanvasAddkeyPanel') {
        // reset the panel
        offcanvasEl.querySelector(".coll_card_welcome_keys").classList.add("show");
        offcanvasEl.querySelector(".coll_gen_new_keypair").classList.remove("show");
        offcanvasEl.querySelector(".coll_card_import_keys").classList.remove("show")
    }

    const offcanvas = await bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
    offcanvas.show();

    if (callback)
        offcanvasEl.addEventListener('hidden.bs.offcanvas', event => {
            callback(event)
        },
            { once: true } // Prevents listener accumulation
        );

    return offcanvas

}
// -------------------------------------------------
export function parseSizeToBytes(input) {

    if (input == null || input == 0)
        return 0

    if (typeof input !== 'string') {
        throw new TypeError('Size must be a string');
    }

    const match = input.trim().match(/^(\d+(?:\.\d+)?)\s*(b|kb|mb|gb|tb)$/i);

    if (!match) {
        throw new Error(`Invalid size format: "${input}"`);
    }

    const value = Number(match[1]);
    const unit = match[2].toLowerCase();

    const MULTIPLIERS = {
        b: 1,
        kb: 1024,
        mb: 1024 ** 2,
        gb: 1024 ** 3,
        tb: 1024 ** 4,
    };

    return Math.round(value * MULTIPLIERS[unit]);
}
// -------------------------------------------------
export async function sha256ToMod(obj, mod) {
    // 1. Stable stringify (important!)
    const str = JSON.stringify(obj, Object.keys(obj).sort());

    // 2. Encode to bytes
    const encoder = new TextEncoder();
    const data = encoder.encode(str);

    // 3. SHA-256 hash
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // 4. Convert first 8 bytes → BigInt (64-bit)
    const view = new DataView(hashBuffer);
    const high = view.getUint32(0);  // first 4 bytes
    const low = view.getUint32(4);  // next 4 bytes

    const hash64 = (BigInt(high) << 32n) | BigInt(low);

    // 5. Modulo
    return Number(hash64 % BigInt(mod));
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export function getUserAvatar(pk) {
    // Expect the key's user ID to carry both fullname and email,
    // e.g. "John Smith <john@example.com>" — standard OpenPGP format.
    const rawUID = pk.myKeyPairUserID[0];
    const match = rawUID.match(/^(.+?)\s*<([^>]+)>$/);
    const user = match
        ? { fullname: match[1].trim(), email: match[2].trim(), pgp_pubkey: pk.myKeyPairPublicKey }
        : { fullname: rawUID, email: rawUID, pgp_pubkey: pk.myKeyPairPublicKey };          // fallback

    return user;

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export async function styleAvatar(el, user, size) {
    // Returns initials from fullname, e.g. "John Smith" → "JS"
    function initials(user) {
        const parts = user.fullname
            .trim()
            .match(/\p{L}+/gu) || [];

        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }

        return (parts[0] || "").slice(0, 2).toUpperCase();
    }

    const avatarColors = [
        ["#cfe2ff", "#084298"], // blue
        ["#d1e7dd", "#0f5132"], // green
        ["#f8d7da", "#842029"], // red
        ["#fff3cd", "#664d03"], // yellow
        ["#e2e3e5", "#41464b"], // gray
        ["#e7d8fd", "#5a2ca0"], // purple
        ["#d0f0fd", "#055160"], // cyan
        ["#fde2e4", "#7a1c2e"], // rose
        ["#e9f5db", "#3c6e0f"], // lime
        ["#ffe5d9", "#8a3b12"], // orange
    ];

    const idx = await sha256ToMod(user.pgp_pubkey, avatarColors.length);

    const [bg, fg] = avatarColors[idx];
    el.style.background = bg;
    el.style.color = fg;
    el.style.width = size + "px";
    el.style.height = size + "px";
    el.style.fontSize = Math.round(size * 0.38) + "px";
    el.textContent = initials(user);
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export function redirect_terms_and_conditions() {
    const url = `${url.origin}${url.pathname}/'?terms-and-conditions'`;
    // location.protocol + "//" + location.hostname + location.pathname + '?terms-and-conditions'
    console.log(url)
    window.open(url, '_blank').focus();
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
export function secondsToHuman(seconds) {

    const units = [
        { label: 'day', value: 86400 },
        { label: 'hour', value: 3600 },
        { label: 'minute', value: 60 },
        { label: 'second', value: 1 }
    ];

    const parts = [];

    for (const { label, value } of units) {
        const amount = Math.floor(seconds / value);
        if (amount > 0) {
            parts.push(`${amount} ${label}${amount > 1 ? 's' : ''}`);
            seconds %= value;
        }
    }

    return parts.length ? parts.join(' ') : '0 seconds';
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export function generate_qr(url, el, color) {

    const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        type: "svg",
        data: url,
        // image: "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
        image: "images/securewink-logo.png",
        dotsOptions: {
            color: color ? color : "#081c45",
            //type: "rounded"
        },
        backgroundOptions: {
            color: "#c7d8d0",
        },
        imageOptions: {
            crossOrigin: "anonymous",
            margin: 20
        }
    });

    qrCode.append(el);

}